<template>
  <div class="layout">
    <transition name="fade">
      <div class="layout-header">
        <Headerbar :hidden="hidden" :status="status"></Headerbar>
      </div>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <Footerbar></Footerbar>
  </div>
</template>
<script>
  import Headerbar from '@/mlayout/component/Headerbar';
  import Footerbar from '@/mlayout/component/Footerbar';
  import Mapbar from '@/mlayout/component/Mapbar';
  export default {
    name: 'layout',
    data() {
      return {
        hidden: true,
        status: true,
        i: 0
      }
    },
    components: {
      Headerbar,
      Footerbar,
      Mapbar
    },
    computed: {
      key() {
        return this.$route.path;
      }
    },
    created() {

    },
    mounted() {
    },
    methods: {
      
    },
    destroyed() {
      
    }
  }
</script>

<style lang="scss" scoped>
  .layout {
    font-size: 0;
    max-width: 7.5rem;
    margin: auto;
  }

  .layout-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 2s
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  // 公共盒子
  .main {
    width: 100%;

    &-inner {
      width: 14.4rem;
      height: 100%;
      margin: auto;
    }
  }

  .ref {
    position: relative;
  }

  .disfx {
    display: flex;
    justify-content: center;
  }

  .fx1 {
    flex: 1;
  }

  .fx1 {
    flex: 2;
  }
</style>



// WEBPACK FOOTER //
// src/mlayout/LayoutFixed.vue